
export interface loveStoryData{
    poeple?:loveStoryPeopleMap;//
    saveRule?:loveStroySaveRule[];//保存规则
    listenRule ?: loveStoryListenRule[];//监听规则
}

//恋爱记的记录接口
export interface loveStoryRecord{
    //npc
    peopleId:string,
    //描述
    explain:string,
    //钱
    coin:number,
    //同意状态  -1 不同意，1 等待同意 ，2 已同意
    agreeStatus:number,
    type : number ;//类型（ 1 存入， 2 取出 ）
    //游戏小时
    gameHour : number,
    //游戏分钟
    gameMinute : number,
    //拒绝理由
    refuseReason ?: string;
}

export interface loveStoryPeople{
    peopleId:string,//操作员标识
    storyRecord:loveStoryRecord[],//操作记录
    meCoin:number,
    otherCoin:number,
    totalCoin : number,//总共金额
    withdrawOptionArray : WithdrawChooseOption[],//提现选项
    registerDay : number,//注册天数
    currDayWithdraw : number,//当天提现次数
}

export interface WithdrawChooseOption {
    peopleId : string;//人物标识
    chooseDesc : string;//选项描述
    withdrawCoinsPercent : number;//提现占比百分比
    withdrawSuccessFlag : boolean;//提现成功标识
    withdrawReplayContent : string;//回复内容
    registerDay ?: number;//注册天数
}

export interface withdrawChooseMap{
    [pId:string]:withdrawOptionMap;
}

export interface withdrawOptionMap{
    [oId:string]:WithdrawChooseOption;
}

export interface loveStoryPeopleMap{
    [id:string]:loveStoryPeople;
}

export enum loveStoryEvent {
    UPDATE_LOVESTORYPREFAB = "love-story-update-prefab",
}

/**
 * npc 定义类
 */
export interface PeopleDefine {
    people : string;//用户姓名标识
    startWeChatId : string;//开始的微信聊天id
}

export interface loveStroySaveRule{
    //开启的天数
    openDay?:number,
    //开启的存款id
    loveStroySaveId:string
}

/**
 * 恋爱屋 监听规则
 */
export interface loveStoryListenRule{
    //开启的天数
    openDay?:number,
    //开启的监听 id
    loveStoryListenId:string
}

//恋爱屋存款接口
export interface loveStroySaveInterface{
    id:string,
    //npcId
    peopleId:string,
    //规则完成之后自动删除
    isAutoDelete?:boolean,
    //需要完成的规则
    saveRuleAry:loveStroySaveRuleInterface[],
}

//恋爱屋单个存款接口
export interface loveStroySaveRuleInterface{
    //需要存入的钱
    coin:number,
    //存入的时间 默认为当天十二点  可以指定在指定的时间存入
    saveTime?:string,
    //需要间隔的天数 不填的话就每天都触发
    intervalDay?:number,
    //存款描述
    explain:string,
}

/**
 * 监听规则
 */
export interface loveStoryListenInterface{
    id:string,
    //npcId
    peopleId:string,
    //规则完成之后自动删除
    isAutoDelete?:boolean,
    //监听规则
    listenRuleAry:loveStoryListenRuleInterface[],
}
//监听规则
export interface loveStoryListenRuleInterface{
    //需要存入的钱
    judgeSaveCoins ?: number,
    //存款描述
    weChatLinkId ?: string,
    //存入的时间 默认为当天十二点  可以指定在指定的时间存入
    saveTime : string,
    //需要间隔的天数 不填的话就每天都触发
    intervalDay ?: number,
    //提示描述
    explain : string;
    //事件id
    eventId : string;
}

//恋爱屋存款接口map
export interface loveStroySaveMap{
    [id:string]:loveStroySaveInterface,
}
//恋爱屋监听接口map
export interface loveStoryListenMap{
    [id:string] : loveStoryListenInterface,
}

export let loveStoryBindPeoples = [
    "沈瑶瑶",
    "薇薇",
    "小芳",
]

/**
 * 获取开始的 微信聊天id
 */
export function getStartWeChatIdByPeople( peopleStr : string ) : PeopleDefine{
    const dataList : PeopleDefine[] = [
        { people : "沈瑶瑶" , startWeChatId : "1101" },
        { people : "薇薇" , startWeChatId : "1108" },
        { people : "小芳" , startWeChatId : "1112" },
    ];
    let findEntity = dataList.find(dataList=>{return dataList.people == peopleStr } );
    return findEntity;
}

let loveStroySaveRuleAry : loveStroySaveInterface[] = null;

/**
 * 存款规则
 */
export function getLoveStroySaveRuleAry():loveStroySaveInterface[]{
    if(!loveStroySaveRuleAry){
        loveStroySaveRuleAry = [
            {id:"0",peopleId:"沈瑶瑶",isAutoDelete:true,saveRuleAry:[{coin:520000,saveTime:"12:00",explain:"沈瑶瑶往恋爱屋存入52w",intervalDay:1},{coin:520000,saveTime:"12:00",explain:"沈瑶瑶往恋爱屋存入52w",intervalDay:2}]},
            {id:"1",peopleId:"小芳",isAutoDelete:true,saveRuleAry:[{coin:10000,saveTime:"15:00",explain:"和别的小美聊天累了吧宝宝，我给你点奶茶。小芳在恋爱屋存入1w",intervalDay:4},{coin:30000,saveTime:"17:00",explain:"今天吃火鸡面嘛，我帮你带。小芳在恋爱屋存入3w",intervalDay:7}]},
        ]
    }
    return loveStroySaveRuleAry;
}

/**
 * 获取故事 存款map
 */
let loveStroySaveRuleMap :loveStroySaveMap = null;
export function getLoveStroySaveRuleMap(){
    if(!loveStroySaveRuleMap){
        loveStroySaveRuleMap = <loveStroySaveMap>{};
        let ary = getLoveStroySaveRuleAry();
        for(let a of ary){
            loveStroySaveRuleMap[a.id] = a;
        }
    }
    return loveStroySaveRuleMap;
}


/**
 * 监听规则
 */
let loveStroyListenRuleAry : loveStoryListenInterface[] = null;
export function getLoveStoryListenAry():loveStoryListenInterface[]{
    if(!loveStroyListenRuleAry){
        loveStroyListenRuleAry = [
            // {id:"0",peopleId:"沈瑶瑶",isAutoDelete:true,listenRuleAry:[{saveTime:"12:00",intervalDay:3,explain:"这就是描述啊描述啊",eventId:"1001",weChatLinkId:"1103"}]},
            {id:"1",peopleId:"小芳",isAutoDelete:true,listenRuleAry:[{saveTime:"14:00",intervalDay:2,explain:"因为你太久没理小芳，她发来提醒:宝宝想你了",eventId:"1002",weChatLinkId:"1113"}]},
            {id:"2",peopleId:"薇薇",isAutoDelete:true,listenRuleAry:[{saveTime:"14:00",intervalDay:2,explain:"因为你太久没理薇薇，她发来提醒：敢不理我？",eventId:"1003",weChatLinkId:"1109"}]},
        ]
    }
    return loveStroyListenRuleAry;
}
/**
 * 获取故事 存款map
 */
let loveStoryListenRuleMap : loveStoryListenMap = null;
export function getLoveStoryListenRuleMap(){
    if(!loveStoryListenRuleMap){
        loveStoryListenRuleMap = <loveStoryListenMap>{};
        let ary = getLoveStoryListenAry();
        for(let a of ary){
            loveStoryListenRuleMap[a.id] = a;
        }
    }
    return loveStoryListenRuleMap;
}
